import React from 'react'
import cx from 'classnames'
import style from './button.module.scss'
import PropTypes from 'prop-types'
import { VegaIcon } from '../icon/Icon'
import { VegaButtonTypes } from './ButtonTypes'

const VegaButton = ({
	className,
	label,
	icon,
	onClick,
	size = 'big',
	disabled = false,
	type = VegaButtonTypes.PRIMARY
}) => {
	return (
		<button
			className={cx(
				className,
				type === VegaButtonTypes.LINK ? style.link : style.button,
				style[type],
				style[size]
			)}
			disabled={disabled}
			onClick={onClick}
		>
			{icon && <VegaIcon className={style.bankIcon} name={icon} size={12} />}
			{label}
		</button>
	)
}

VegaButton.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Label of the button */
	label: PropTypes.string,
	/** Icon name of button */
	icon: PropTypes.string,
	/** Set action on click */
	onClick: PropTypes.func,
	/** Set size of button */
	size: PropTypes.oneOf(['big', 'normal']),
	/** Set disabled state */
	disabled: PropTypes.bool,
	/** Set type of button */
	type: PropTypes.oneOf(Object.values(VegaButtonTypes)),
	/** To preventDefault click action */
	isSubmit: PropTypes.bool
}

export { VegaButton, VegaButtonTypes }
